import React, { useRef, useEffect, useState } from 'react';

const spriteSrc =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAHCAYAAAD5wDa1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozNDNFMzM5REEyMkUxMUUzOEE3NEI3Q0U1QUIzMTc4NiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozNDNFMzM5RUEyMkUxMUUzOEE3NEI3Q0U1QUIzMTc4NiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjM0M0UzMzlCQTIyRTExRTM4QTc0QjdDRTVBQjMxNzg2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjM0M0UzMzlDQTIyRTExRTM4QTc0QjdDRTVBQjMxNzg2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+jzOsUQAAANhJREFUeNqsks0KhCAUhW/Sz6pFSc1AD9HL+OBFbdsVOKWLajH9EE7GFBEjOMxcUNHD8dxPBCEE/DKyLGMqraoqcd4j0ChpUmlBEGCFRBzH2dbj5JycJAn90CEpy1J2SK4apVSM4yiKonhePYwxMU2TaJrm8BpykpWmKQ3D8FbX9SOO4/tOhDEG0zRhGAZo2xaiKDLyPGeSyPM8sCxr868+WC/mvu9j13XBtm1ACME8z7AsC/R9r0fGOf+arOu6jUwS7l6tT/B+xo+aDFRo5BykHfav3/gSYAAtIdQ1IT0puAAAAABJRU5ErkJggg=='
// Create sprite
const sprite = new Image()
sprite.src = spriteSrc
const spriteCoords = [0, 6, 13, 20];
const flickerSpeedConstants = {
    slowest: 50,
    slower: 20,
    slow: 12,
    normal: 7,
    fast: 4,
    faster: 2,
    fastest: 0,
}
const randomHexColor = () => {
    // http://www.paulirish.com/2009/random-hex-color-code-snippets/
    return `#${`000000${Math.floor(Math.random() * 16777215).toString(
        16
    )}`.slice(-6)}`
};

const getSpriteVariant = () => {
    return spriteCoords[Math.floor(Math.random() * spriteCoords.length)]
};

const getOpacity = () => {
    return Math.random()
};

const Sparkle = ({
    color = 'random',
    count = 50,
    minSize = 5,
    maxSize = 8,
    overflowPxX = 20,
    overflowPxY = 20,
    height = 40,
    width = 40,
    fadeOutSpeed = 50,
    newSparkleOnFadeOut = true,
    flicker = true,
    flickerSpeed = 'normal',
    use_circle = true,
    children = null,
    canvasClassName = null,
    ...props
}) => {
    const containerRef = useRef(null);
    const sparkleCanvasRef = useRef(null);
    const sparklesRef = useRef([]);
    useEffect(() => {
        // Set initial canvas size based on container
        resizeCanvas();

        const initialSparkles = createInitialSparkles();
        sparklesRef.current = (initialSparkles);

        const animationFrame = requestAnimationFrame(() => updateSparkles());

        return () => {
            cancelAnimationFrame(animationFrame);
        };
    }, []);

    const resizeCanvas = () => {
        const canvas = sparkleCanvasRef.current;
        const container = containerRef.current;

        if (canvas && container) {
            canvas.width = container.offsetWidth + 2 * width;
            canvas.height = container.offsetHeight + 2 * height;
        }
    };

    const createInitialSparkles = () => {
        const newSparkles = [];
        for (let i = 0; i < count; i++) {
            newSparkles.push(createSparkle());
        }
        return newSparkles;
    };

    const createSparkle = () => {
        const canvas = sparkleCanvasRef.current;
        if (!canvas) {
            return null;
        }

        const size = randomSparkleSize();
        return {
            position: {
                x: Math.random() * (canvas.width - size),
                y: Math.random() * (canvas.height - size),
            },
            size,
            opacity: getOpacity(),
            color: getRandomColor(),
            variant: getSpriteVariant(),
        };
    };

    const randomSparkleSize = () => {
        return Math.floor(Math.random() * (maxSize - minSize + 1) + minSize);
    };

    const getRandomColor = () => {
        if (color === 'random') {
            return randomHexColor();
        } else if (Array.isArray(color)) {
            return color[Math.floor(Math.random() * color.length)];
        } else {
            return color;
        }
    };


    const updateSparkles = () => {
        const canvas = sparkleCanvasRef.current;
        if (!canvas) {
            return;
        }

        sparklesRef.current = sparklesRef.current.map(sparkle => {
            let updatedSparkle = { ...sparkle };

            // Update opacity
            updatedSparkle.opacity -= 0.001 * fadeOutSpeed;
            if (updatedSparkle.opacity < 0) {
                if (newSparkleOnFadeOut) {
                    updatedSparkle = createSparkle();
                } else {
                    updatedSparkle.opacity = getOpacity();
                }
            }

            // Update flicker effect
            if (flicker) {
                const flickerSpeedConstant = flickerSpeedConstants[flickerSpeed];
                if (Math.random() < 1 / flickerSpeedConstant) {
                    updatedSparkle.variant = getSpriteVariant();
                }
            }

            return updatedSparkle;
        })

        drawSparkles(use_circle);

        // Continue the animation
        requestAnimationFrame(updateSparkles);
    };

    const drawSparkles = (use_circle) => {
        const canvas = sparkleCanvasRef.current;
        const context = canvas.getContext('2d');

        if (!canvas || !context) {
            return;
        }

        // Clear the canvas
        context.clearRect(0, 0, canvas.width, canvas.height);

        // Draw each sparkle
        sparklesRef.current.forEach(sparkle => {
            const { position, size, color, opacity, variant } = sparkle;

            // Save the current state
            context.save();

            // Set global alpha for opacity
            context.globalAlpha = opacity;

            if (use_circle) {
                // Draw a circle
                context.beginPath();
                context.arc(position.x + size / 2, position.y + size / 2, size / 2, 0, 2 * Math.PI);
                context.fillStyle = color || 'white'; // Default to white if no color specified
                context.fill();
            } else {
                // Draw the sparkle sprite
                context.drawImage(
                    sprite,
                    variant,
                    0,
                    7,
                    7,
                    position.x,
                    position.y,
                    size,
                    size
                );

                // Apply color tint if specified
                if (color) {
                    context.globalCompositeOperation = 'source-atop';
                    context.fillStyle = color;
                    context.fillRect(position.x, position.y, size, size);
                }
            }

            // Restore the context to its original state
            context.restore();
        });
    };


    return (
        <div
            ref={containerRef}
            style={{
                position: 'relative',
                // overflow: 'hidden',
                ...props.style
            }}
            {...props}
        >
            <canvas
                className={canvasClassName}
                ref={sparkleCanvasRef}
                style={{
                    position: 'absolute',
                    pointerEvents: 'none',
                    top: `${overflowPxY}px`,
                    left: `${overflowPxX}px`,
                }}
            />
            {children}
        </div>
    );
};

export default Sparkle;
